import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class AppTopbar extends Component {

    static defaultProps = {
        onToggleMenu: null
    }

    static propTypes = {
        onToggleMenu: PropTypes.func.isRequired
    }

    render() {

        return (
            <div>
            <div id="pgrBar">%</div>
            <div className="layout-topbar clearfix">                
                <div className="p-fluid">
                    <div className="p-grid">
                        <div className="p-col-1">
                            <a className="layout-menu-button" onClick={this.props.onToggleMenu}>
                                <span className="pi pi-bars" style={{color:'#6e84a3'}}/>
                            </a>                        
                        </div>

                        <div className="p-col-10">
                            <div className="tituloTop">Tzion MyResult</div>
                        </div>

                        <div className="p-col-1">
                            <div style={{visibility:"hidden"}}  className="layout-topbar-icons">                            
                                <a onClick={() => {window.location = '#/selecionar-medico'}}>
                                    <span className="layout-topbar-item-text">Pesquisar</span>
                                    <span className="layout-topbar-icon pi pi-search"  style={{color:'#6e84a3'}}/>
                                </a>
                            </div>                                               
                        </div>
                       
                    </div>
                </div>                            
            </div>
            </div>
        );
    }
}

  
export default connect()(AppTopbar);